export const ApplePayIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.7501 47.9C49.2251 45.65 49.7751 44.5 50.9001 41.975C42.6001 38.825 41.2751 27 49.4751 22.475C46.9751 19.325 43.4501 17.5 40.1251 17.5C37.7251 17.5 36.0751 18.125 34.6001 18.7C33.3501 19.175 32.2251 19.6 30.8251 19.6C29.3251 19.6 28.0001 19.125 26.6001 18.625C25.1001 18.075 23.5001 17.5 21.5001 17.5C17.7751 17.5 13.8001 19.775 11.2751 23.675C7.72508 29.175 8.35006 39.475 14.0751 48.275C16.1251 51.425 18.8751 54.95 22.4501 55C23.9501 55.025 24.9251 54.575 26.0001 54.1C27.2251 53.55 28.5501 52.95 30.8751 52.95C33.2001 52.925 34.5001 53.55 35.7251 54.1C36.7751 54.575 37.7251 55.025 39.2001 55C42.8001 54.95 45.7001 51.05 47.7501 47.9Z"
      fill={strokeColor}
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.6001 5C40.0001 7.75 38.8751 10.475 37.4001 12.375C35.8251 14.425 33.0751 16.025 30.4251 15.925C29.9501 13.275 31.1751 10.55 32.6751 8.72499C34.3501 6.72499 37.1751 5.175 39.6001 5Z"
      fill={strokeColor}
    />
  </svg>
);
